import React from 'react';
import { SecondaryAppBar } from '@marageti/z4-lib';
import { ViewProps } from './types';
import TabsView from './tabs-view';

const SubNavigationView = ({
  profile,
  startAdornment = undefined,
  endAdornment = undefined,
  tabs = undefined,
  sx = {},
}: ViewProps) => (
  <SecondaryAppBar
    collapsing
    position="sticky"
    color="default"
    profile={profile}
    startAdornment={startAdornment}
    endAdornment={endAdornment}
    tabs={
      tabs ? <TabsView tabs={tabs} /> : undefined
    }
    sx={sx}
  />
);

export default SubNavigationView;
